export default "__VITE_ASSET__BZjHEbc4__";